/**
 * vue-toastification `filterBeforeCreate` süzgeci (DEV-3902).
 *
 *  - İçeriği metin olmayan (Error, AxiosError, undefined) ya da boş metin olan toast'lar
 *    `bildirimMetni` ile string'e çevrilir: kütüphane nesneyi metin olarak basamaz ve BOŞ bir
 *    toast çıkardı.
 *    Bileşen/VNode içerikli toast'a dokunulmaz.
 *  - Aynı tür ve aynı metinli bir toast ekranda zaten görünüyorsa yenisi oluşturulmaz
 *    (tekrarlayan hata toast yığını).
 *
 * Saf tutuldu (store/DOM bağımlılığı yok) ki birim testten geçebilsin.
 */
import {bildirimMetni} from '@/plugins/uyap-plugin/bildirimMetni';

export interface ToastBenzeri {
    type?: unknown;
    content?: unknown;
}

function bilesenMi(icerik: unknown): boolean {
    if (typeof icerik === 'function') {
        return true;
    }
    if (!icerik || typeof icerik !== 'object') {
        return false;
    }
    const o = icerik as {component?: unknown, render?: unknown, tag?: unknown};
    return o.component !== undefined || o.render !== undefined || o.tag !== undefined;
}

export function toastFiltresi<T extends ToastBenzeri>(toast: T, mevcutlar: ToastBenzeri[] | null | undefined): false | T {
    const bosMetin = typeof toast.content === 'string' && toast.content.trim() === '';
    if (bosMetin || (typeof toast.content !== 'string' && !bilesenMi(toast.content))) {
        toast.content = bildirimMetni(toast.content);
    }
    const ayniVar = (mevcutlar ?? []).some(
        (m) => !!m && m.type === toast.type && m.content === toast.content
    );
    return ayniVar ? false : toast;
}
